<template>
  <div class="currency-selector" v-click-outside="hideCurrencyList">
    <p class="selected-currency" :class="{ 'active' : showCurrencyList }" @click="showCurrencyList = !showCurrencyList">{{ selectedCurrency }}</p>

    <div class="currency-list" v-if="showCurrencyList">
      <ul>
        <li v-for="(currency, currencyIndex) in $t('currencies')" :key="currencyIndex">
          <a @click="setCurrencyCode(currency.code)" v-if="currency.name !== selectedCurrency.name" title="language.name">
            {{ currency.name }} <span class="code">{{ currency.code }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CurrencyChanger',
  data() {
    return {
      OpenIndicator: {
          render: createElement => createElement('i', {class: {'fa fa-chevron-down': true}}),
      },
      selectedCurrency: '',
      showCurrencyList: false
    }
  },

  methods: {
    hideCurrencyList: function() {
      this.showCurrencyList = false;
    },

    setCurrencyCode(value) {
      let self = this;

      self.$store.dispatch('setCurrencyCode', value);
      self.selectedCurrency = self.getCurrencyCode;
      self.hideCurrencyList();

      if (self.$route.name === 'FlightsList' || self.$route.name === 'HotelsList' || self.$route.name === 'HotelListing') {
        self.$route.params.currency = value;
      }
      self.$router.push(self.$route).catch(() => {});
    }
  },

  created () {
    let self = this;
    let routeCurrency = self.$route.params.currency;
    self.selectedCurrency = routeCurrency ? routeCurrency : self.getCurrencyCode;

    if (routeCurrency) {
      let currency = self.$t('currencies').find(currency => currency.code.toLowerCase() === routeCurrency.toLowerCase());
      if (currency) {
        self.$store.dispatch('setCurrencyCode', currency.code);
      }
    }
  },

  computed: {
    ...mapGetters ([
      'getCurrencyCode'
    ]),
  },

  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
          el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
              vnode.context[binding.expression](event);
          }
          };
          document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
          document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    }
  }
}
</script>